module.exports = __webpack_public_path__ + "static/key-crimsonland-bc6f7da66ed48b799e5b9877e35eaa12.webp";